import { render, staticRenderFns } from "./InputLocalizedText.vue?vue&type=template&id=4fd5cf18"
import script from "./InputLocalizedText.vue?vue&type=script&lang=js"
export * from "./InputLocalizedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports